import { Quote } from "lucide-react";
import Reveal from "./Reveal";
import { placeholder } from "../../lib/constants";

export default function Testimonials({ items, sectionContent, uiStrings, sectionId }) {
  const ts = uiStrings?.testimonials_section || {};
  const eyebrow = ts.eyebrow || sectionContent?.eyebrow || placeholder("short");
  const headline = ts.headline || sectionContent?.headline || placeholder("medium");
  const description = ts.description || sectionContent?.description || "";

  return (
    <section data-id="site-testimonials" id={sectionId} className="bg-softblack text-offwhite py-28 md:py-40 relative grain overflow-hidden">
      <div data-id="testimonials-bg-glow"
        className="absolute inset-0 pointer-events-none opacity-40"
        style={{ background: "radial-gradient(60% 60% at 30% 20%, rgba(200,169,126,0.18), transparent 70%)" }}
      />
      <div data-id="testimonials-container" className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div data-id="testimonials-header" className="grid lg:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-20">
          <Reveal className="lg:col-span-5">
            <p className="eyebrow !text-champagne/80" data-id="testimonials-eyebrow">{eyebrow}</p>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-offwhite mt-4 md:mt-6 leading-[1.05]" data-id="testimonials-headline">
              {headline}
            </h2>
          </Reveal>
          {description && (
            <Reveal delay={200} className="lg:col-span-6 lg:col-start-7 lg:pt-6">
              <p className="text-fendi/80 text-sm sm:text-base md:text-lg leading-relaxed font-light" data-id="testimonials-description">
                {description}
              </p>
            </Reveal>
          )}
        </div>

        <div data-id="testimonials-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {items.map((t, idx) => (
            <Reveal
              key={t.uid}
              delay={idx * 120}
              className="relative border-l border-champagne/40 pl-5 md:pl-8"
            >
              <Quote className="text-champagne mb-4 md:mb-6" size={20} strokeWidth={1} />
              <p className="font-serif text-xl sm:text-2xl md:text-[26px] leading-snug text-offwhite italic font-light" data-id={`testimonial-quote-${t.uid}`}>
                "{t.quote}"
              </p>
              <div data-id={`testimonial-author-${t.uid}`} className="mt-6 md:mt-8 pt-4 md:pt-6 border-t border-fendi/20">
                <p className="text-offwhite text-sm tracking-wide font-medium" data-id={`testimonial-name-${t.uid}`}>{t.name}</p>
                {t.role && <p className="eyebrow !text-warmgray mt-1" data-id={`testimonial-role-${t.uid}`}>{t.role}</p>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
